import useSWRMutation from 'swr/mutation';
import { SuccessResponse } from '@interfaces/central-monitoring';
import {
    AddSubjectActionModel,
    UpdateSubjectActionModel,
    DeleteSubjectActionModel,
    BulkUpdateSubjectActionsDto,
} from '@interfaces-clean/subject-monitoring/subject-actions';
import {
    EmailSubjectActionsModel,
    SubjectActionsEmailPreviewDto,
} from '@interfaces-clean/subject-monitoring/subject-actions-email.interface';
import { postData } from '@apis/rest-client';

const actionsUrl = 'SubjectMonitoring/SubjectActions';

const SubjectActionsApi = {
    useSave: (studyRef: string) => {
        return useSWRMutation(
            `${actionsUrl}/Add/${studyRef}`,
            (url: string, { arg }: { arg: AddSubjectActionModel }) => {
                return postData<AddSubjectActionModel, SuccessResponse>(url, { arg, timeout: 30000 });
            },
        );
    },
    useUpdate: (studyRef: string) => {
        return useSWRMutation(
            `${actionsUrl}/Update/${studyRef}`,
            (url: string, { arg }: { arg: UpdateSubjectActionModel }) => {
                return postData<UpdateSubjectActionModel, SuccessResponse>(url, { arg, timeout: 30000 });
            },
        );
    },
    useDelete: (studyRef: string) => {
        return useSWRMutation(
            `${actionsUrl}/Delete/${studyRef}`,
            (url: string, { arg }: { arg: DeleteSubjectActionModel }) => {
                return postData<DeleteSubjectActionModel, boolean>(url, { arg, timeout: 30000 });
            },
        );
    },
    usePreviewEmail: (studyRef: string) => {
        return useSWRMutation(`${actionsUrl}/Email/Preview/${studyRef}`, (url: string, { arg }: { arg: number[] }) => {
            return postData<number[], SubjectActionsEmailPreviewDto | null>(url, { arg, timeout: 30000 });
        });
    },
    useSendEmail: (studyRef: string) => {
        return useSWRMutation(
            `${actionsUrl}/Email/${studyRef}`,
            (url: string, { arg }: { arg: EmailSubjectActionsModel }) => {
                return postData<EmailSubjectActionsModel, boolean>(url, { arg, timeout: 30000 });
            },
        );
    },
    useBulkUpdate: (studyRef: string) => {
        return useSWRMutation(
            `${actionsUrl}/BulkUpdate/${studyRef}`,
            (url: string, { arg }: { arg: BulkUpdateSubjectActionsDto }) => {
                return postData<BulkUpdateSubjectActionsDto, boolean>(url, { arg, timeout: 30000 });
            },
        );
    },
};

export default SubjectActionsApi;
